<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'FORGOT_PASSWORD' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p class="info-text">{{ 'FORGOT_PASSWORD_INFO' | translate }}</p>

  <form (ngSubmit)="resetPassword()" #resetForm="ngForm">
    <ion-list>
      <ion-item>
        <ion-input
          label="{{ 'EMAIL' | translate }}"
          labelPlacement="floating"
          type="email"
          [(ngModel)]="email"
          name="email"
          required
          email
        ></ion-input>
      </ion-item>
    </ion-list>

    <div class="ion-padding-top">
      <ion-button
        type="submit"
        expand="block"
        color="tertiary"
        [disabled]="resetForm.invalid || isSubmitting">
        <ion-spinner *ngIf="isSubmitting" name="crescent"></ion-spinner>
        <span *ngIf="!isSubmitting">{{ 'REQUEST_RESET_LINK' | translate }}</span>
      </ion-button>
    </div>
  </form>

  <p *ngIf="resetSuccess" class="success-message">{{ resetSuccess }}</p>
  <p *ngIf="resetError" class="error-message">{{ resetError }}</p>

  <div class="ion-text-center ion-padding-top">
    <a (click)="backToLogin()" class="back-link">{{ 'BACK_TO_LOGIN' | translate }}</a>
  </div>
</ion-content>